// eslint-disable-next-line
// @ts-ignore: just requiring images paths in build time
const images = require.context('../../../assets/images', true);

export const imagePath = (name?: string) => {
  return name ? images(name, true) : '';
};
